import { useMemo } from 'react';
import { SearchModality } from '../feature/search-table-company/hooks/types';
import { SearchTable, SearchType } from '../types';
import {
  useSearchRouteInfo,
  useSearchSimilarityFromRoute,
} from './use-obtain-search-type-from-route';
import { useSearchModality } from './use-search-modality';

export function useGetCreditsAmountTypeOnActionPopup() {
  const { type, table } = useSearchRouteInfo();
  const isSimilarity = useSearchSimilarityFromRoute();
  const { modality } = useSearchModality();

  return useMemo(() => {
    const isCompany = type === SearchType.Company;
    const isPeople = type === SearchType.People;
    const isCompanyEmployees = table === SearchTable.Employees;
    const isPeopleOrEmployees = isPeople || isCompanyEmployees;
    const isPeopleModality = !!modality;
    const isUnsavedModality = modality === SearchModality.UNSAVED;

    // If these flags are indeed always true, we can omit them.
    const basicCompany = !isSimilarity && isCompany;
    const aiCompany = isSimilarity && isCompany;
    const basicPeople =
      isPeopleOrEmployees &&
      !isSimilarity &&
      (!isPeopleModality || !isUnsavedModality);
    const aiPeople =
      isPeopleOrEmployees &&
      isSimilarity &&
      (!isPeopleModality || !isUnsavedModality);
    const basicUnsavedPeople =
      isPeopleOrEmployees &&
      !isSimilarity &&
      isPeopleModality &&
      isUnsavedModality;
    const aiUnsavedPeople =
      isPeopleOrEmployees &&
      isSimilarity &&
      isPeopleModality &&
      isUnsavedModality;

    return {
      basicCompany,
      aiCompany,
      basicPeople,
      aiPeople,
      basicUnsavedPeople,
      aiUnsavedPeople,
    };
  }, [type, table, isSimilarity, modality]);
}
